import React, { useState, useEffect } from 'react';
import SnapshotList from './SnapshotList';
import SnapshotManagerResult from '../snapshot-manager-page/SnapshotManagerResult';
import SnapshotInformation from '../snapshot-manager-page/SnapshotInformation'

import './SnapshotManagerMain.css'

const SnapshotManagerMain = (props) => {
  const [snapshotLabelData, setSnapshotLabelData] = useState();
  const [selectedSnapshot, setSelectedSnapshot] = useState();
  const [selectedSnapshotQuery, setSelectedSnapshotQuery] = useState();
  const [queryData, setQueryData] = useState();

  useEffect(() => {
    setSnapshotLabelData(props.snapshotLabelData);
  }, [props.snapshotLabelData]);

  useEffect(() => {
    setSelectedSnapshot(props.selectedSnapshot);
  }, [props.selectedSnapshot]);

  useEffect(() => {
    setQueryData(props.queryData);
  }, [props.queryData]);

  useEffect(() => {
    setSelectedSnapshotQuery(props.selectedSnapshotQuery);
  }, [props.selectedSnapshotQuery]);

  return(
    // <div className="manageSnapshotBoxLR">
    <div className="row featured-main">
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td width="22%" valign="top">
              {snapshotLabelData &&
                <div className="manageSnapshotLeft">
                  <SnapshotList handleClick={props.handleSelectedSnapshot} snapshotLabelData={snapshotLabelData}
                    handleSearchBtn={props.handleSearchBtn} snapshotFilter={props.snapshotFilter} handleSearchInput={props.handleSearchInput} filteredArray={props.filteredArray}
                  />
                </div>
              }
          </td>
          <td width="78%" valign="top">
            {selectedSnapshot && selectedSnapshotQuery && queryData &&
              <div className="manageSnapshotRight">
                <SnapshotInformation snapshotInfo={selectedSnapshot} queryData={queryData} selectedSnapshotQuery={selectedSnapshotQuery}
                handleRemoveBtn={props.handleRemoveBtn} handleRunBtn={props.handleRunBtn}
              />
              </div>
            }
            <div className="snapshotResult">
              <SnapshotManagerResult volumeResult={props.volumeResult} sentimentResult={props.sentimentResult} sourceResult={props.sourceResult} categoryResult={props.categoryResult} relationResult={props.relationResult} positioningmapResult={props.positioningmapResult} options={props.options} 
              userRole={props.userRole}/>
            </div>
          </td>
        </tr>
      </table>
    </div>
  )
} 

export default SnapshotManagerMain;